import { createConsumptionDataNode } from './utils/dataNodeUtils'
import { getContextFromInflatedId } from '../../../byRefUtils'
import { getItemsList } from '../../../templateNodes/dataNodes/Behaviors'
import { ObsoleteBehaviorsList, pointers } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { ENVIRONMENT_NAMESPACE, INFLATED_DATA } from '../../../constants'
import { getDataItemRefsWithOverrides, resolveOverrideItem } from '../../dataConsumption'
import { DependenciesData } from './types'
import { createRef } from '@wix/materializer'
import type { Ref } from '@wix/thunderbolt-types'
import type { BeckyModel } from '@wix/thunderbolt-becky-root/dist'

type Dependencies = {
	dataItemWithOverrides: Array<Ref<ObsoleteBehaviorsList>>
	editorName: Ref<string>
}

export const Behaviors = createConsumptionDataNode<DependenciesData, Dependencies, Dependencies>({
	getDependencies: (data) => ({
		dataItemWithOverrides: getDataItemRefsWithOverrides(data) as Array<Ref<ObsoleteBehaviorsList>>,
		editorName: createRef<BeckyModel['editorName']>([ENVIRONMENT_NAMESPACE, ENVIRONMENT_NAMESPACE, 'editorName']),
	}),
	toViewItem: ({ id, value, rawModel }) => {
		const { dataItemWithOverrides, editorName } = value

		const dataItems = _(dataItemWithOverrides)
			.filter((dataItem) => !!dataItem)
			.value()

		if (dataItems.length === 0) {
			return
		}

		const resolvedBehaviorDataItem = resolveOverrideItem(dataItemWithOverrides, id) as ObsoleteBehaviorsList

		// This node was created to handle a bug in hamburger menu, the solution isn't applicable to
		// studio sites because of a bug where the source id of the action behavior is always the same (the template compId)
		// Once the new hamburger menu is released we can remove this check.
		if (editorName === 'Studio') {
			return resolvedBehaviorDataItem
		}

		let shouldUpdateData = true
		const existingData = _.get(rawModel, [INFLATED_DATA, pointers.data.DATA_MAPS.BEHAVIORS, id])
		const context = getContextFromInflatedId(id)

		const itemsList = getItemsList(resolvedBehaviorDataItem.items)
		_.forEach(itemsList, (actionBehaviorItem) => {
			const actionSourceId = _.get(actionBehaviorItem, ['action', 'sourceId'])

			if (actionSourceId && getContextFromInflatedId(actionSourceId) !== context) {
				shouldUpdateData = false
			}
		})

		// since the template comp can be consumed in different refComps, but is still dependent on the same dataItem,
		// we need to make sure we don't override the original behavior dataItem
		return shouldUpdateData ? resolvedBehaviorDataItem : existingData
	},
})
